import { render, staticRenderFns } from "./Evacuacao.vue?vue&type=template&id=a2e1bd48&"
import script from "./Evacuacao.vue?vue&type=script&lang=js&"
export * from "./Evacuacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports